import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'components/Tile/components';

const BannerProgressBar = ({ theme, video }) => <ProgressBar theme={theme} video={video} />;

export default BannerProgressBar;

BannerProgressBar.defaultProps = {
  theme: {},
  video: null,
};

BannerProgressBar.propTypes = {
  theme: PropTypes.shape({}),
  video: PropTypes.shape({}),
};
